<template>
  <div
    class="home_wrap"
    :style="all_game_list.length == 0 ? 'height:100vh' : ''"
  >
    <van-nav-bar
      title="Pesquisar jogos"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- 搜索 -->
    <div
      v-show="true"
      class="search-wrap"
    >
      <input
        v-model="keyword"
        class="input-keyword"
        type="text"
        placeholder="Pesquisar"
        @blur="getSearchData"
      >
      <van-icon
        name="search"
        class="simg"
        @clic="getSearchData"
      />
    </div>
    <div class="game-bg">
      <div id="game-left-bg">
        <div
          class="game-left-item"
          :class="left_active == 0 ? 'nav_ac' : ''"
          @click="changeLeftNav(0)"
        >
          <img
            class="nav_img"
            src="../../assets/images/subGame/2.webp"
          >
          <!-- <img v-else class="nav_img" src="../../assets/images/category/PG.png" /> -->
          <span class="ppl">Pesquisar</span>
        </div>
        <div
          class="game-left-item"
          :class="left_active == 1 ? 'nav_ac' : ''"
          @click="changeLeftNav(1)"
        >
          <img
            class="nav_img"
            src="../../assets/images/subGame/4.webp"
          >
          <!-- <img v-else class="nav_img" src="../../assets/images/category/PP.png" /> -->
          <span class="ppl">Popular</span>
        </div>
        <div
          class="game-left-item"
          :class="left_active == 2 ? 'nav_ac' : ''"
          @click="changeLeftNav(2)"
        >
          <img
            class="nav_img"
            src="../../assets/images/subGame/3.webp"
          >
          <!-- <img v-else class="nav_img" src="../../assets/images/category/TADA.png" /> -->
          <span class="ppl">Recente</span>
        </div>
        <!-- <div class="game-left-item" @click="changeLeftNav(3)" :class="left_active == 4 ? 'nav_ac' : ''">
          <img class="nav_img" src="../../assets/images/subGame/1.webp" />
          <img v-else class="nav_img" src="../../assets/images/category/JDB.png" />
          <span class="ppl">Favoritos</span>
       </div>  -->
        <!-- <div class="game-left-item" @click="changeLeftNav(5)" :class="left_active == 5 ? 'nav_ac' : ''">
          <img v-if="left_active == 5" class="nav_img" src="../../assets/images/category/CPa.png" />
          <img v-else class="nav_img" src="../../assets/images/category/CP.png" />
          <span class="ppl">CP</span>
        </div> -->
      </div>
      <div id="game-right-bg">
        <div
          v-if="all_game_list.length == 0"
          class="nonew-list"
        >
          <img
            src="../../assets/images/category/noList.png"
            alt=""
          >
          <p>Nenhum jogo disponível</p>
        </div>
        <!-- <div v-else v-for="(game, idx) in all_game_list" :id="'game' + idx" :key="idx" class="new-list"> -->
        <!-- <div v-for="(game_t, tidx) in game" :key="tidx"> -->
        <!-- <div class="c-sm-des">
              <img
                src="../../assets/images/common/title_left.png"
                class="sec-img"
              />
              <span class="sec-title">{{ idx + " " + tidx }}</span>
              <img
                src="../../assets/images/common/title_right.png"
                class="sec-img"
              />
            </div> -->
        <div
          class="game-list"
          :style="{ height: screenHeight + 'px' }"
        >
          <div
            v-for="(item, index) in all_game_list"
            v-show="index < step_show"
            :key="index"
            class="subgame-item"
            @click="
              playGame(item.game_id, item.origin, item.id, item.is_works)
            "
          >
            <div
              v-lazy:background-image="item.img"
              class="innerbox"
            >
              <img
                v-if="!item.is_works"
                src="../../assets/images/common/nowork.png"
                class="nowork"
              >
              <div
                v-if=" item.origin != 'CP'"
                class="subgame_item_pg_name"
              >
                {{ item.game_name }}
              </div>
            </div>
          </div>
          <div
            v-show="all_game_list.length > step_show"
            class="show_more"
            @click="showMore()"
          >
            <div>
              A exibir {{ step_show }} jogos entre
              {{ all_game_list.length }} Popular jogos
            </div>
            Mostre mais ⇊
          </div>
        </div>
        <!-- </div> -->
        <!-- </div> -->
        <!-- 分页栏 -->
        <!-- <div
          id="geme-page"
          style="
            position: fixed;
            bottom: 8%;
            left: 20%;
            right: 0;
            display: flex;
          "
        >
          <van-pagination
            v-model="currentPage"
            :page-count="pagecount"
            :total-items="all_game_list.length"
            :items-per-page="perPage"
            @change="PageChange"
            force-ellipses
          />
        </div> -->
      </div>
    </div>
    <div
      v-show="show_game_box"
      id="bigBox"
      class="game-box"
    >
      <!--    <div class="game-box" id="bigBox" v-show="true">-->
      <!-- <iframe :src="game_url" frameborder="0" id="myiframe"></iframe> -->
      <div
        class="back_to_desk"
        @click="beforeCloseGame()"
      >
        <van-icon
          name="wap-home-o"
          class="close_game_btn"
        />
        <div style="font-size: 0.3rem">
          Sair
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Lazyload, Pagination, Tabs, Tab } from "vant";
import Fetch from "../../utils/fetch";
import Axios from "axios";
Vue.use(NavBar).use(Pagination).use(Tabs).use(Tab).use(Lazyload, {
  lazyComponent: true,
});

export default {
  name: "SubGame",
  components: {},
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      keyword: "",
      gamestile: "Slots",
      all_game_list: [],
      all_game_list_bak: [],
      page_game_list: [],
      nav_active: 0,
      perPage: 30,
      step_show: 28,
      max_show_array: [6, 6, 6, 6],
      currentPage: 1,
      category: "type",
      show_game_box: false,
      is_ban: 0,
      username: null,
      i: 0,
      pagecount: 8,
      nav_active: 0,
      left_active: 0,
      result: {},
      timer: false,
      screenHeight: "",
    };
  },
  watch: {
    pagecount: function (newn, oldn) {
      // console.log(newn, oldn);
    },
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight);
          that.timer = false;
        }, 400);
      }
    },

    keyword: function (newn) {
    },
  },
  created() {
    this.$parent.show_left_nav = false;
    this.getGameList();
    this.getUserInfo();
  },
  mounted() {
    console.log()
    window.screenHeight = document.body.clientHeight - 110;
    this.screenHeight = window.screenHeight;
    var that = this;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight - 110;
        that.screenHeight = window.screenHeight;
        // console.log(that.screenHeight);
      })();
    };
  },
  methods: {
    getSearchData() {
      if (this.keyword == '') {
        this.getGameList();
        return;
      }
      if (this.left_active !== 0) {
        this.left_active = 0;
        // this.getGameList();
      }
      Fetch("/game/searchGames", {
        keyword: this.keyword
      }, { method: "get" }).then(res => {
        if (res.data.length) {
          this.all_game_list = res.data;
        } else {
          this.all_game_list = [];
        }
      })
    },
    PageChange() {
      // console.log(1);
      this.all_game_list = [];
      let allGames = [];
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      if (this.nav_active == 0) {
        allGames = this.all_game_list_bak[0].game_list.concat(
          this.all_game_list_bak[1].game_list
        );
        //this.pagecount = Math.ceil(allGames.length / this.perPage);
      } else if (this.nav_active == 1) {
        allGames = this.all_game_list_bak[0].game_list;
      } else if (this.nav_active == 2) {
        allGames = this.all_game_list_bak[1].game_list;
      }
      const gameKeys = Object.keys(allGames);
      let res = [];
      for (let i = startIndex; i < endIndex && i < gameKeys.length; i++) {
        const key = gameKeys[i];
        const value = allGames[key];
        res.push(value);
      }
      this.all_game_list.push({
        origin: "Slots",
        game_list: res,
      });
      // console.log(this.all_game_list);
    },
    beforeCloseGame() {
      document
        .getElementById("bigBox")
        .removeChild(document.getElementById("myiframe"));
      this.show_game_box = false;
      this.game_url = "";
      //重新获取用户的余额
      this.getUserInfo();
      // Fetch("/box/getTodaybetInfo", {}, false, true).then((r) => {
      //   this.todayInfo = r.data;
      //   this.$confirm(
      //     `Você apostou ${r.data.today_bet_amount} e completou ${
      //       r.data.percent
      //     }%, restando ${
      //       100 - r.data.percent
      //     }% para reivindicar bônus de apostas adicionais.`,
      //     {
      //       confirmButtonText: "Continuar o jogo",
      //       cancelButtonText: "Deixe o jogo",
      //       // type: 'warning',
      //       showClose: false,
      //       center: true,
      //     }
      //   )
      //     .then((e) => {
      //       console.log("用户选择了继续游戏...", e);
      //     })
      //     .catch((e) => {
      //       console.log(e);
      //     });
      // });
    },
    showMore(idx) {
      this.step_show += 28;
    },

    getGameList() {
      Fetch("/game/gameTypeList", {
        flag: this.left_active,
      }, { method: "get" }).then((res) => {
        if (res.data.length) {
          this.result = res.data.slots;
          this.all_game_list = res.data;
          this.all_game_list_bak = res.data;
        } else {
          this.all_game_list = res.data;
          this.all_game_list_bak = res.data;
        }

      });
    },
    changeLeftNav(idx) {
      // this.tabChange(idx);
      if (idx !== 0) {
        this.keyword = ""
      }
      this.left_active = idx
      this.getGameList(idx)
      // console.log(idx);
    },
    getListData(name) {
      console.log(name)
      return {
        slots: {
          name: this.result[name]
        }
      }
    },
    tabChange(v) {
      this.nav_active = v;
      if (v == 0) {
        this.all_game_list = this.getListData("all");
        this.all_game_list_bak = this.getListData("all");
      } else {
        this.all_game_list = [];
        this.all_game_list_bak = [];
      }
      // if (v == 1) this.category = "";
      // if (v == 2) this.category = "";
      // if (v == 3) this.category = "";
      // if (v == 4) this.category = "";
      // if (v == 5) this.category = "";
      // this.getGameList();
    },
    getUserInfo() {
      Fetch("/user/is_login").then((r) => {
        if (r.data) {
          this.userInfo = r.data;
          this.username = r.data.username;
          this.userbalance = r.data.money;
          this.is_ban = r.data.is_rob;
        } else {
        }
      });
    },
    async playGame(gameId, origin, jdb_game_id, is_work) {
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          if (origin != "PG") {
            return this.$message({
              message: "Contas simuladas só podem jogar jogos PG",
              type: "error",
            });
          }
        }
      }
      if (!this.username) {
        this.$parent.login();
        return;
      } else {
        //被后台禁止游戏了
        if (this.is_ban) {
          this.$toast({
            background: "#07c160",
            message:
              "Sua conta atual ainda não ativou as funções do jogo, entre em contato com seu gerente",
            duration: 5000,
          });
          return;
        }
        if (is_work == 0) {
          this.$toast({
            background: "#07c160",
            message: "Este jogo está em manutençãoe",
            duration: 5000,
          });
          return;
        }
        if (this.userbalance < 0.4) {
          return this.$parent.isShowRecharge = true;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      // 添加本地缓存
      let localGames = localStorage.getItem("local_game_list");
      if (!localGames) {
        let json_obj = { PG: [], JDB: [], TADA: [] };
        localStorage.setItem("local_game_list", JSON.stringify(json_obj));
        localGames = localStorage.getItem("local_game_list");
      }

      localGames = JSON.parse(localGames);
      console.log(localGames.PG);
      //return false;
      //存入本地最近游戏游戏列表中
      if (localGames[origin] && localGames[origin].indexOf(jdb_game_id) == -1) {
        localGames[origin].push(jdb_game_id);
        localStorage.setItem("local_game_list", JSON.stringify(localGames));
      }
      let reGameList = await this.getRecent(jdb_game_id, origin);
      console.log(reGameList, '最近游戏')
      //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
      if (origin == "JDB") {
        //先获取一下游戏的链接
        let resp = await this.getJDBtoken(jdb_game_id);
        return this.launchJDB(resp.data);
      }

      if (origin == "TADA") {
        //先获取一下游戏的链接
        let resp = await this.getJiliUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "CP") {
        //先获取一下游戏的链接
        let resp = await this.getCPUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "PP") {
        //先获取一下游戏的链接
        let resp = await this.getPPUrl(gameId);
        return this.launchJDB(resp.data);
      }

      //PG
      if (origin == "PG") {
        this.show_game_box = true;
        var iframe = document.createElement("iframe");
        iframe.setAttribute("height", "100%");
        iframe.setAttribute("width", "100%");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("id", "myiframe");
        let l = localStorage.getItem("lang");
        let game_l = "pt";
        if (l == "pt_br") game_l = "pt";
        if (l == "en_us") game_l = "en";
        if (l == "zh_cn") game_l = "zh";
        this.game_url = await this.getPGHtml(gameId);
        if (this.game_url.data) {
          this.launchJDB(this.game_url.data.url);
        } else {
          iframe.addEventListener("load", function () {
            console.log("iframe loaded!");
          });
          var bigBox = document.getElementById("bigBox");
          bigBox.appendChild(iframe);
          iframe.contentWindow.document.open();
          iframe.contentWindow.document.write(this.game_url);
          iframe.contentWindow.document.close();
        }
      }
    },
    launchJDB(url) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("webkitallowfullscreen", "true");
      iframe.setAttribute("mozallowfullscreen", "true");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },

    createIframe(content) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
      iframe.contentWindow.document.write(
        "<script>alert(1); window.location.href = " + content + ""
      );
    },
    getPGHtml(game_id) {
      // console.log(this.userInfo);return null;
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          let _this = this;
          return new Promise((resolve, reject) => {
            Axios.post("https://test.carnaval88.com/api/demo/getPGHtml2", {
              game_id: game_id,
              user: _this.userInfo,
            })
              .then(function (response) {
                resolve(response.data);
              })
              .catch(function (error) {
                reject(error);
              });
          });
        }
      }

      return new Promise((resolve) => {
        Fetch(
          "/demo/getPGHtml2",
          { game_id: game_id, token: localStorage.getItem("token") },
          {},
          true
        ).then((res) => {
          resolve(res);
        });
      });
    },
    getRecent(game_id, origin) {
      return new Promise((resolve) => {
        Fetch("/game/addRecent", { game_id: game_id, origin: origin }, false, false).then(
          (res) => {
            resolve(res);
          }
        );
      });
    },
    getJDBtoken(gameId) {
      return new Promise((resolve) => {
        Fetch("/jdb_game/jdbtoken", { id: gameId }, false, false).then(
          (res) => {
            resolve(res);
          }
        );
      });
    },
    getCPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/cp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getPPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/pp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getJiliUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/jili/game_url", { id: gameId }, false, false).then((res) => {
          if (res.code == 1) resolve(res);
          //resolve("https://www.google.com");
        });
      });
    },
    onClickLeft() {
      this.$router.push("/");
    },
  },
  // directives: {
  //   'debounce-input': {
  //     inserted(el, binding) {
  //       let timeout
  //       el.addEventListener('input', () => {
  //         clearTimeout(timeout)
  //         timeout = setTimeout(() => {
  //           binding.value()
  //         }, parseInt(binding.arg) || 300)
  //       })
  //     }
  //   }
  // }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @primary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: @textcolor1;
}

/deep/ .van-nav-bar__title {
  color: @textcolor1;
}

// .tab_nav {
//   background-color: @secondary-color;
//   background-size: cover;
// }

/deep/ .van-tabs__wrap--scrollable {
  /* 自定义样式 */
  color: @anttextcolor;
  background: transparent;
  border-width: 1.5rem;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  color: @textcolorf;
}

/deep/ .van-tabs__wrap--scrollable .van-tab--active {

  background-color: @ButtonColor;
}

.van-tab--active .ppl {
  color: @activityColor !important;
}

/deep/ .van-tab {
  width: 2rem;
  height: .6rem;
  border-radius: .2rem;
  // border-bottom: 0.01 solid @bodercolor;
  margin-right: .2rem;
  background: @secondary-color;
  border: 0.01rem solid @bodercolor;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  height: auto;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0 !important;
}

/deep/ .van-tabs__line {
  bottom: 0 !important;
}

.ppl {
  font-size: .3rem;
  margin-left: .2rem;
}

.game-bg {
  // display: flex;
  // align-items: center;
}

#game-right-bg {
  // width: 75%;
}

#game-left-bg {
  width: 95%;
  display: flex;
  justify-content: space-around;
  border-bottom: 0.01rem solid @bodercolor;
  margin: 0 auto;
}

.home_wrap {
  height: 100%;
  background-color: @activityColor;
}

.nav_title {
  // display: flex;
  // align-items: center;
}

.search-wrap {
  //background: rgba(250, 223, 0,0.8);
  border: 1px solid @bodercolor;
  height: 0.6rem;
  width: 95%;
  margin: 0.3rem auto 0.1rem auto;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: @primary-color;
}

.simg {
  font-size: 0.4rem;
  margin-right: 0.2rem;
  color: @textcolor1;
}

.nonew-list {
  width: 100%;
  text-align: center;
  margin-top: 4rem;

  img {
    width: 105px;
    height: 105px;
  }

  p {
    font-size: .3rem;
    color: @textcolor1;
  }
}

.nav_ac {
  span {
    color: @ButtonColor !important;
  }
}

.input-keyword {
  width: 70%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
  float: left;
  text-indent: 10px;
  background: none;
  border: none;

  input {
    background: none;
    border: none;
    outline: none;
  }
}

.input-keyword::placeholder {
  color: @textcolor1
}

.show_more {
  color: @anttextcolor;
  width: 95%;
  margin: 0 auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;

  div {
    height: 0.5rem;
    line-height: 0.5rem;
    color: @textcolor3;
  }
}

.game-left-item {
  // width: 80%;
  color: #c7c7c7;
  display: flex;
  align-items: center;
  // background: @secondary-color;
  // border-radius: 0.2rem;
  // border-radius: 48%;
  // margin: 0.2rem 0 0rem 0rem;
  padding: 0.02rem 0;
  text-align: center;
  height: 0.7rem;
  // height: 1.3rem;
}

.path_ac {
  fill: @activityColor !important;
}

.nav_ac {
  color: #000;
  // background-color: @ButtonColor;
  border-bottom: 0.05rem solid @ButtonColor;
}

.nav_img {
  display: block;
  width: .5rem;
  height: .5rem;
  margin: 0 auto;
}

::-webkit-scrollbar {
  display: none;
}

.game-list {
  width: 95%;
  overflow-y: scroll;
  margin: 0.2rem auto 0rem auto;
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: space-start;
}

.subgame-item {
  width: 31%;
  height: 3.6rem;
  margin-right: .16rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.new-list {
  position: relative;
  margin-bottom: 0.3rem;
}

.nowork {
  width: 2.8rem;
  height: 3.7rem;
  position: relative;
  z-index: 2;
  background: rgba(0, 0, 0, 0.34);
  margin: 0 auto;
}

.game-left-item {
  svg {
    path {
      fill: @ButtonColor;
    }
  }
}

.innerbox {
  width: 100%;
  height: 3.6rem;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  box-sizing: border-box;
  // border: 1px solid #feb705;
  margin: 0 auto;
}

.subgame_item_pg_name {
  color: #fff;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin: 0 auto;
  width: 100%;
  font-size: 0.3rem;
  // font-weight: 500;
  left: 0;
  bottom: -0.15rem;
  height: 1.1rem;
  // line-height: 0.5rem;
}

.game_name {
  width: 100%;
  text-align: center;
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
  bottom: 0.3rem;
  color: #fff;
  font-size: 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  //background-color: rgba(0, 0, 0,0.5);
}

.gameimg-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.game-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.2rem;
}

.game-name {
  font-size: 0.3rem;
  color: #c7c7c7;
  text-align: center;
}

.c-sm-des {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  border-radius: 4px;
  height: 0.8rem;

  img {
    width: 1.8rem;
  }
}

.sec-title {
  color: #fff;
  font-size: 0.35rem;
  line-height: 0.6rem;
  //margin-left: 0.25rem;
}

.game-box {
  position: fixed;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  bottom: 0;
  // left: 0;
  // right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.back_to_desk {
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  height: 1rem;
  width: 1rem;
  // display: flex;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 0.02rem solid #fff;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem 0.2rem;
}

.close_game_btn {
  font-size: 0.8rem;
  border-radius: 50%;
  color: #fff;
}
</style>
